import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslatePipe } from '@ngx-translate/core';
import { CtaButtonComponent } from '../../../../shared/components/ui/cta-button/cta-button.component';
import { PatrolDiscordApiService } from '../../services/patrol-discord-api.service';
import { PatrolDiscordCockpitService } from '../../services/patrol-discord-cockpit.service';

@Component({
  selector: 'app-patrol-discord-bot-callback',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    TranslatePipe,
    MatProgressSpinnerModule,
    CtaButtonComponent,
  ],
  templateUrl: './patrol-discord-bot-callback.component.html',
  styleUrl: './patrol-discord-bot-callback.component.scss',
})
export class PatrolDiscordBotCallbackComponent implements OnInit {
  #route = inject(ActivatedRoute);
  #router = inject(Router);
  #api = inject(PatrolDiscordApiService);
  #cockpit = inject(PatrolDiscordCockpitService);

  readonly isLoading = signal(true);
  readonly errorKey = signal<string | null>(null);

  ngOnInit(): void {
    void this.#handleCallback();
  }

  async #handleCallback(): Promise<void> {
    const registryId = this.#route.snapshot.queryParamMap.get('state')?.trim();
    const guildId = this.#route.snapshot.queryParamMap.get('guild_id')?.trim();

    if (!registryId || !guildId) {
      this.errorKey.set('app.patrol.discord.cockpit.connect.callbackMissingParams');
      this.isLoading.set(false);
      return;
    }

    try {
      await this.#api.completeGuildLink(registryId, guildId);
      await this.#cockpit.refresh();
      await this.#router.navigate(['/discord'], { replaceUrl: true });
    } catch {
      this.errorKey.set('app.patrol.discord.cockpit.connect.callbackFailed');
      this.isLoading.set(false);
    }
  }
}
